import { useSelector } from 'react-redux';
import Global from '../../../../../../../store/global-selectors';
import { useIs3PLPlanEnabledForSeller } from '../../../../../../../hooks/use-is-3pl-plan-enabled-for-seller';
import { useIsLocaleAnEnglishVariant } from '../../../../../../../intl/hooks';
import { AU, CA, GB, NZ, US } from '../../../../../../../constants/country-codes';

const EligibleHomeCountries = [AU, CA, GB, NZ, US];

export const useShouldDirectUserToBrightback = () => {
  const is3PL = useIs3PLPlanEnabledForSeller();
  const isEnglishSpeaker = useIsLocaleAnEnglishVariant();
  const homeCountry = useSelector(Global.selectSellerHomeCountry);
  const isInEligibleCountry = EligibleHomeCountries.includes(homeCountry);

  const shouldDirectUserToBrightback = isEnglishSpeaker && isInEligibleCountry && !is3PL;

  return shouldDirectUserToBrightback;
};
